/* nabi — sets page: add-the-set buttons + mix & match builder */
(function () {
  'use strict';
  const money = cents => {
    const fmt = (window.nabi && window.nabi.moneyFormat) || '${{amount}}';
    const amt = (cents / 100).toFixed(2), noDec = Math.round(cents / 100).toString();
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount(_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, amt).replace(/<[^>]+>/g, '').replace(/\.00$/, '');
  };
  const addItems = async (ids, btn, opts) => {
    const items = ids.filter(Boolean).map(id => ({ id: parseInt(id, 10), quantity: 1 })).filter(i => i.id);
    if (!items.length) { window.nabi.toast(btn.dataset.addMissing || 'Not linked to products yet'); return false; }
    btn.classList.add('loading');
    try { await window.nabi.addToCart(items, opts || { open: false }); btn.classList.remove('loading'); return true; }
    catch (e) { window.nabi.toast(e.message); btn.classList.remove('loading'); return false; }
  };

  /* set rows */
  document.querySelectorAll('[data-add-set]').forEach(b => {
    if (b.dataset.bound) return; b.dataset.bound = '1';
    let t;
    b.addEventListener('click', async () => {
      const ok = await addItems(b.dataset.addSet.split(','), b);
      if (!ok) return;
      b.classList.add('added'); clearTimeout(t);
      t = setTimeout(() => { b.classList.remove('added'); if (window.nabi.cartDrawerEnabled) window.nabi.openCart(); }, 1600);
    });
  });

  /* mix & match */
  const mix = document.querySelector('[data-mix]');
  if (!mix || mix.dataset.bound) return; mix.dataset.bound = '1';
  const disc = parseInt(mix.dataset.discount || '10', 10);
  const ys = mix.querySelector('[data-yourset]');
  const sel = { top: null, bottom: null };
  const label = { top: mix.querySelector('[data-picked="top"]'), bottom: mix.querySelector('[data-picked="bottom"]') };
  const nothing = label.top ? label.top.textContent : 'nothing yet';
  const groups = { top: mix.querySelector('[data-group="top"]'), bottom: mix.querySelector('[data-group="bottom"]') };
  const variantOf = card => { const s = card.querySelector('[data-msel]'); return s ? s.value : card.dataset.variant; };
  const update = () => {
    const a = sel.top, b = sel.bottom;
    label.top.textContent = a ? a.dataset.name.replace(/^The /, 'the ') : nothing;
    label.bottom.textContent = b ? b.dataset.name.replace(/^The /, 'the ') : nothing;
    if (a && b) {
      const apart = (+a.dataset.cents || 0) + (+b.dataset.cents || 0);
      const together = Math.round(apart * (100 - disc) / 100);
      ys.querySelector('[data-ys-pair]').innerHTML = `<i style="background:${a.dataset.hex}"></i><i style="background:${b.dataset.hex}"></i>`;
      ys.querySelector('[data-ys-name]').textContent = a.dataset.name + ' + ' + b.dataset.name;
      ys.querySelector('[data-ys-price]').innerHTML = `${money(apart)} apart<em>together ${money(together)}</em>`;
      ys.classList.add('show');
    } else ys.classList.remove('show');
  };
  const wire = key => {
    const el = groups[key]; if (!el) return;
    el.addEventListener('click', e => {
      if (e.target.closest('[data-msel]')) return;
      const card = e.target.closest('.mp'); if (!card) return;
      sel[key] = sel[key] === card ? null : card;
      el.querySelectorAll('.mp').forEach(x => x.classList.toggle('on', x === sel[key]));
      update();
    });
    el.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('mp')) { e.preventDefault(); e.target.click(); } });
  };
  wire('top'); wire('bottom');
  const addBtn = ys.querySelector('[data-ys-add]');
  addBtn.addEventListener('click', async () => {
    if (!sel.top || !sel.bottom) return;
    const ok = await addItems([variantOf(sel.top), variantOf(sel.bottom)], addBtn);
    if (!ok) return;
    addBtn.textContent = addBtn.dataset.added;
    setTimeout(() => {
      addBtn.textContent = addBtn.dataset.label;
      sel.top = sel.bottom = null; mix.querySelectorAll('.mp.on').forEach(x => x.classList.remove('on')); update();
      if (window.nabi.cartDrawerEnabled) window.nabi.openCart();
    }, 1400);
  });
})();
